// Value types a shared index field can be created with. Shared by the Field
// Library page's create form and the Publish node's "+ New index field" modal.
export const VALUE_TYPES = ['text', 'number', 'date', 'currency', 'boolean', 'table'];
